<div class="add" :style="`width: ${size}px; height: ${size}px`" @click="$emit('add')"><span></span><span></span></div>